export default {
  // Options.jsx
  items_per_page: '/ page',
  label_items_per_page: 'Items / page',
  jump_to: 'Aller à',
  jump_to_confirm: 'confirmer',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Page précédente',
  next_page: 'Page suivante',
  prev_5: '5 Pages précédentes',
  next_5: '5 Pages suivantes',
  prev_3: '3 Pages précédentes',
  next_3: '3 Pages suivantes',
};
